export function ScheduleSkeleton({
  field = false,
  calendar = false,
}: {
  field?: boolean;
  calendar?: boolean;
}) {
  return (
    <div
      className={`schedule-skeleton${calendar ? " schedule-skeleton--calendar" : ""}`}
      role="status"
      aria-label={field ? "Loading published field" : "Loading races"}
    >
      <span className="sr-only">
        {field ? "Loading published field…" : "Loading races…"}
      </span>
      {Array.from({ length: field ? 6 : 5 }, (_, index) => (
        <div
          className={
            field ? "schedule-skeleton__field" : "schedule-skeleton__row"
          }
          key={index}
          aria-hidden="true"
        >
          <span />
          <span />
          <span />
          <span />
        </div>
      ))}
    </div>
  );
}

export function ScheduleError({
  title,
  retry,
}: {
  title: string;
  retry: () => void;
}) {
  return (
    <div className="schedule-message schedule-message--error" role="alert">
      <strong>{title}</strong>
      <p>Try again to load the published data.</p>
      <button type="button" className="schedule-button" onClick={retry}>
        Retry
      </button>
    </div>
  );
}

export function ScheduleEmpty({
  title,
  detail,
}: {
  title: string;
  detail: string;
}) {
  return (
    <div className="schedule-message">
      <strong>{title}</strong>
      <p>{detail}</p>
    </div>
  );
}
